module.exports = require("../../../node_modules/.pnpm/arraybuffer-loader@1.0.8/node_modules/arraybuffer-loader/lib/to-array-buffer.js")("")